import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import Span from '@deliveroo/consumer-component-library/components/Span';
import classnames from 'classnames';
import FilterButton from '../FilterButton';
import styles from './styles.scss';

/**
 * Used to show a list of city filters.
 */
const CityFilter = ({
  cities,
  label,
  mobileLabel,
  viewMoreLabel,
  onViewMore,
  onSelectItem,
  selectedIndex,
}) => {
  if (!cities.length) return null;

  return (
    <div className={styles.wrapper}>
      <Span color="grey" size="small" spacing="0 large 0 0">
        <span className={classnames(styles.label, styles.mobile)}>
          {mobileLabel && mobileLabel}
        </span>
        <span className={classnames(styles.label, styles.default)}>{label}</span>
      </Span>
      {cities.map((city, index) => (
        <FilterButton
          isSelected={index === selectedIndex}
          onClick={onSelectItem(city, index)}
          key={`city-select-${city.compareValue}`}
        >
          {city.displayName}
        </FilterButton>
      ))}
      {viewMoreLabel && <FilterButton onClick={onViewMore}>{viewMoreLabel}</FilterButton>}
    </div>
  );
};

CityFilter.propTypes = {
  /**
   * A list of cities to display in the filter
   */
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      compareValue: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
    }),
  ).isRequired,
  /**
   * The label to display before the list of cities
   */
  label: PropTypes.string,
  /**
   * The label to display before the list of cities (mobile-specific)
   */
  mobileLabel: PropTypes.string,
  /**
   * The label to display for the 'view more' button
   */
  viewMoreLabel: PropTypes.string,
  /**
   * A function to handle onClick for the 'view more' button
   */
  onViewMore: isRequiredIf(PropTypes.func, (props) => props.viewMoreLabel),
  /**
   * A function to handle onClick for each city
   */
  onSelectItem: PropTypes.func.isRequired,
  /**
   * The index of the currently-selected city
   */
  selectedIndex: PropTypes.number,
};

CityFilter.defaultProps = {
  label: 'Filter by city:',
  mobileLabel: 'Filter by:',
  viewMoreLabel: null,
  onViewMore: () => {},
  selectedIndex: null,
};

export default CityFilter;
